module.exports = __webpack_public_path__ + "img/3.6c881863.png";